// extracted by mini-css-extract-plugin
module.exports = {"container":"logo-module--container--2ePwd","logo":"logo-module--logo--RSQ2K"};